import React, {useEffect, useRef, useState} from "react";
import CambioIdioma from "../scripts/CambioIdioma";
import Datos from "../../utilidades/Colecciones.json";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
export default function SelectBuscadorUno(){
  const _updateFiltros= useStoreGlobal(useShallow((state) => state._updateFiltros));
  const _filtros= useStoreGlobal(useShallow((state) => state._filtros));
    const [optionsFil, setOptionsFiltros] = useState([]);
    const selectFil = useRef(null);
    const buscaren = useRef(null);
    const [selectedFiltros, setSelectedFiltros] = useState("");
    let var_ingles = "es";
    if (window.location.href.indexOf("en.") > -1) {
        var_ingles = "en";
    }
    const handleSelectChangeFiltro = (event) => {
        const camposBuscador = event.target.value;
        setSelectedFiltros(camposBuscador);
        _updateFiltros({camposBuscador:camposBuscador});
        _updateFiltros({paginaFin:10});
        $("#search").trigger("click");
    }
    let coleccion = "";
    if(Object.keys(_filtros).length >= 1){
      coleccion = _filtros.coleccion;
    }
    useEffect(() => {
        if (buscaren !== null) {
          CambioIdioma.valida(var_ingles, buscaren);
        }
        let x=[];
        if (coleccion =="Areageograficas"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].areas.español);
            x=Datos[0].areas.español;
          } else {
            setOptionsFiltros(Datos[0].areas.ingles);
            x=Datos[0].areas.español;
          }
        }
        if (coleccion =="Datos_abiertos"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].datosAbiertos.español);
            x=Datos[0].datosAbiertos.español;
          } else {
            setOptionsFiltros(Datos[0].datosAbiertos.ingles);
            x=Datos[0].datosAbiertos.español;
          }
        }
        if (coleccion =="DENUE"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].denue.español);
            x=Datos[0].denue.español;
          } else {
            setOptionsFiltros(Datos[0].denue.ingles);
            x=Datos[0].denue.español;
          }
        }
        if (coleccion =="Glosario"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].glosario.español);
            x=Datos[0].glosario.español;
          } else {
            setOptionsFiltros(Datos[0].glosario.ingles);
            x=Datos[0].glosario.español;
          }
        }
        if (coleccion =="Indicadores"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].indicadores.español);
            x=Datos[0].indicadores.español;
          } else {
            setOptionsFiltros(Datos[0].indicadores.ingles);
            x=Datos[0].indicadores.español;
          }
        }
        if (coleccion =="Infraestructura"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].infraestructura.español);
            x=Datos[0].infraestructura.español;
          } else {
            setOptionsFiltros(Datos[0].infraestructura.ingles);
            x=Datos[0].infraestructura.español;
          }
        }
        if (coleccion =="Investigación"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].investigacion.español);
            x=Datos[0].investigacion.español;
          } else {
            setOptionsFiltros(Datos[0].investigacion.ingles);
            x=Datos[0].investigacion.español;
          }
        }
        if (coleccion =="Microdatos"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].microdatos.español);
            x=Datos[0].microdatos.español;
          } else {
            setOptionsFiltros(Datos[0].microdatos.ingles);
            x=Datos[0].microdatos.español;
          }
        }
        if (coleccion =="Noticias"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].noticias.español);
            x=Datos[0].noticias.español;
          } else {
            setOptionsFiltros(Datos[0].noticias.ingles);
            x=Datos[0].noticias.español;
          }
        }
        if (coleccion =="Programas"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].programas.español);
            x=Datos[0].programas.español;
          } else {
            setOptionsFiltros(Datos[0].programas.ingles);
            x=Datos[0].programas.español;
          }
        } 
        if (coleccion =="Publicaciones"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].publicaciones.español);
            x=Datos[0].publicaciones.español;
          } else {
            setOptionsFiltros(Datos[0].publicaciones.ingles);
            x=Datos[0].publicaciones.español;
          }
        }
        if (coleccion =="Tabulados"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].tabulados.español);
            x=Datos[0].tabulados.español;
          } else {
            setOptionsFiltros(Datos[0].tabulados.ingles);
            x=Datos[0].tabulados.español;
          }
        }
        if (coleccion =="Temas"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].temas.español);
            x=Datos[0].temas.español;
          } else {
            setOptionsFiltros(Datos[0].temas.ingles);
            x=Datos[0].temas.español;
          }
        }
        if((coleccion !== "Todo" && coleccion !== "Mapas" && coleccion !== "Herramintas") && x.length > 0){
          const valor = x[0].value;
          setSelectedFiltros(valor);
          _updateFiltros({camposBuscador:valor});
        }
    }, [coleccion]);
    return(
      <div className="col-sm-12 col-md-11 col-lg-3" id="idBuscador">
      <div id="todo_buscar">
        <div className="tamanoalineacioncombos" id="todobuscaen">
          <div className="row">
            <div
              className="col-md-2 col-lg-2 col-11"
              id="rowbuscador"
              style={{ paddingRight: "50px" }}
            >
              <div id="buscaren" ref={buscaren}></div>
            </div>
            <div className="tamChec2 form-check-inline col-md-11 col-lg-7 col-11" id="buscara">
              <select
                className="form-select"
                ref={selectFil}
                value={selectedFiltros}
                onChange={handleSelectChangeFiltro}
                name="Filtros"
                id="selectfiltros"
              >
                {optionsFil.map((filtros,i) => (
                  <option key={"coleccionesBuscadorTodos-" + i} value={filtros.value}>
                    {filtros.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
};